import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { clientsDataList } from "../../../redux/user/action";
import { Modal } from "reactstrap";
import AddClient from "./AddClient";
import UpdateClient from "./UpdateClient";

const ClientList = ({ id }) => {
  const [sinlgeId, setSingleId] = useState(null);
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);

  const [params, setParams] = useState({
    parent_id: Number(id),
    page: 1,
    search_key: "",
    category_id: "",
  });

  const clientsData = useSelector(
    (state) => state?.reusableSlice?.getClientData
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clientsDataList(params));
  }, [dispatch, params]);

  const getClientId = (id) => {
    setSingleId(id);
    setModals(!modals)
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <AddClient
          id={id}
          modal={modal}
          setModal={setModal}
          params={params}
          setParams={setParams}
        />
      </Modal>
      <Modal isOpen={modals} toggle={() => setModals(!modals)}>
        <UpdateClient
          id={id}
          sinlgeId={sinlgeId}
          modal={modals}
          setModal={setModals}
          params={params}
          setParams={setParams}
        />
      </Modal>
      <div>
        <div className="table-sec p-0">
          <button
            onClick={() => setModal(!modal)}
            className="background-button d-block mb-3  ml-auto"
            style={{ width: "max-content" }}
          >
            <span>Add Client</span>
          </button>

          <table className="table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Company Name</th>
                <th>Email id</th>
                <th>Mobile Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {clientsData?.users?.length > 0 ? (
                clientsData?.users?.map((addr, index) => (
                  <tr key={addr.id}>
                    <td>{index + 1 + (params?.page - 1) * 10}</td>
                    <td>{addr?.full_name}</td>
                    <td>{addr?.email_id}</td>
                    <td>
                      {addr?.country_code} {addr?.mobile_number}
                    </td>
                    <td>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          className="border-button"
                          onClick={() => {
                            getClientId(addr?.id);
                          }}
                          // onClick={() => setModals(!modals)}
                        >
                          <span
                          >
                            Update
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ClientList;
